import { useSize } from "../../lib/useSize";
import { fmtKpi, shortLabel, type ChartPoint } from "../../lib/dashboard";

/** Kütüphanesiz çizgi (opsiyonel alan dolgulu) grafik — token renk. */
export function LineChart({ data, color, area, unit }: { data: ChartPoint[]; color: string; area?: boolean; unit?: string | null }) {
  const [ref, { width, height }] = useSize<HTMLDivElement>();
  const vals = data.map((d) => d.value ?? 0);
  const maxV = Math.max(...vals, 0);
  const minV = Math.min(...vals, 0);
  const span = maxV - minV || 1;
  const padL = 6, padR = 6, padT = 12, padB = 20;
  const plotW = Math.max(0, width - padL - padR);
  const plotH = Math.max(0, height - padT - padB);
  const n = data.length;
  const xAt = (i: number) => (n <= 1 ? padL + plotW / 2 : padL + (i / (n - 1)) * plotW);
  const yAt = (v: number) => padT + plotH - ((v - minV) / span) * plotH;
  const linePts = data.map((d, i) => `${xAt(i).toFixed(1)},${yAt(d.value ?? 0).toFixed(1)}`).join(" ");
  const areaPts = `${padL},${(padT + plotH).toFixed(1)} ${linePts} ${(padL + plotW).toFixed(1)},${(padT + plotH).toFixed(1)}`;
  return (
    <div ref={ref} className="dash-chart">
      {width > 8 && height > 8 && n > 0 ? (
        <svg width={width} height={height} role="img" aria-label="Çizgi grafik">
          <line x1={padL} y1={padT + plotH} x2={padL + plotW} y2={padT + plotH} stroke="var(--neutral-200)" strokeWidth={1} />
          {area ? <polygon points={areaPts} fill={color} opacity={0.12} /> : null}
          {n > 1 ? <polyline points={linePts} fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" /> : null}
          {data.map((d, i) => (
            <circle key={i} cx={xAt(i)} cy={yAt(d.value ?? 0)} r={2.6} fill={color}>
              <title>{d.label}: {fmtKpi(d.value)}{unit ? " " + unit : ""}</title>
            </circle>
          ))}
          {n <= 16 ? data.map((d, i) => <text key={i} x={xAt(i)} y={padT + plotH + 13} textAnchor="middle" className="dash-chart-x">{shortLabel(d.label)}</text>) : null}
        </svg>
      ) : null}
    </div>
  );
}
